module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Bitcoin-c40c42e2c0c960a757e193af0490ec6d.svg";